export default __webpack_public_path__ + "821ed18dec913b336ff060168f41d840.svg";